<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div class="mt-4">
    <register-form
      baseUrl="https://partners.lemanapro.ru/api"
      @registration-success="onRegister"
    />
    <b-modal
      id="register-modal"
      v-model="success"
      :hide-header="true"
      :hide-footer="true"
    >
      <div>
        <a
          href
          class="icon close"
          @click.stop.prevent="$bvModal.hide('register-modal')"
        />
      </div>
      <div class="row">
        <div class="col-10 col-md-10 offset-md-1 offset-1">
          <h3 class="text-center">
            Регистрация
          </h3>
          <p class="help_text text-center mt-3">
            На email {{ email }} отправлено письмо.
          </p>
          <p class="help_text text-center mb-3">
            Перейдите по ссылке в письме для подтверждения почты
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style>
.orgType-select {
  border-radius: 0.25em 0 0 0.25em;
}

.col-form-label {
  font-size: 12px !important;
}

.custom-select {
  font-size: 12px !important;
}
</style>

<script>
import 'iap-auth';

export default {
  name: 'RegistrationForm',
  data() {
    return {
      success: false,
      email: '',
    };
  },
  methods: {
    onRegister(evt) {
      this.email = evt.detail.email;
      this.success = true;
      window.dataLayer.push({
        event: 'LeroyMerlin_Forms',
        eventCategory: 'Interactions',
        eventAction: 'submit',
        eventLabel: 'form / registration',
        eventLocation: 'Landing',
        eventContent: 'Регистрация',
        eventContext: 'Заполните заявку и начните зарабатывать с нами',
      });
    },
  },
};
</script>

<style lang="scss">
  .form-button {
    background: #FDC300 !important;
    border-radius: 4px !important;
    border: 1px solid #FDC300 !important;
    color: black !important;
    text-transform: uppercase;
    padding: 0.5rem 1rem;
    font-weight: 500;
  }

  .form-input[type=email], .form-input[type=password], #form-input[type=text]:not(.input-prepend) {
    font-size: 14px;
    padding: 10px 10px 5px 0px;
    display: block;
    width: 100%;
    border: none;
    border-radius: 0;
    background: none;
    color: black;
    border-bottom: 1px solid #e0e0e0;
  }

  .input-field:not(.taxation,.vat) > span {
    display: none;
  }

  .input-password-field > span {
    display: none;
  }

  email-input, password-input {
    flex: 1 !important;
  }

  password-input {
    margin-bottom: 8px;
  }

  .info-text > span {
    flex: 0;
  }

  .info-text > small {
    flex: 1;
  }

  .taxation > span , .vat > span {
    font-size: 12px;
  }

  .form-input:focus:not(.input-prepend) {
    border-bottom: 1px solid #FDC300 !important;
  }

  .taxation > div {
    display: flex;
    flex: 0.65;
  }

  .vat > div {
    display: flex;
    flex: 0.65;
  }
</style>
